import {
    VehicleDataVINFeatures,
    VehicleDataYMMFeatures,
} from '../../../services/vehicle-data-service/vehicle-data-service.types';
import { getPublicCategories } from './category-utils';
import { FilterFeatureArgs, UiFeature } from './vehicle-features.types';

function containsOnly(array1: any[], array2: any[]) {
    return array2.every(elem => array1.includes(elem));
}

export function filterVehicleFeaturesUnAuth(
    args: FilterFeatureArgs
): UiFeature[] | null {
    const categories: string[] = getPublicCategories(
        args.vehicleType,
        args.currentLanguageRegionCode
    ).flatMap(f => f.displayName);

    const featuresToReturn: VehicleDataYMMFeatures[] = [];
    const seenTopicIds = new Set<number>();

    args.allFeatures
        .filter(
            feature => feature.categoryNames && feature.categoryNames.length
        )
        .filter(
            feature =>
                feature.categoryNames?.includes(categories[0]) ||
                feature.categoryNames?.includes(categories[1])
        )
        .forEach(feature => {
            if (containsOnly(feature.categoryNames!, categories)) {
                if (feature.topicId && !seenTopicIds.has(feature.topicId)) {
                    featuresToReturn.push(feature);
                    if (feature.topicId != null) {
                        seenTopicIds.add(feature?.topicId);
                    }
                }
            }
            if (feature.categoryNames!.length === 1) {
                if (feature.topicId && !seenTopicIds.has(feature.topicId)) {
                    featuresToReturn.push(feature);
                    if (feature.topicId != null) {
                        seenTopicIds.add(feature?.topicId);
                    }
                }
            }
        });
    return featuresToReturn;
}

export function filterVinResponse(
    features: VehicleDataVINFeatures[]
): VehicleDataVINFeatures[] {
    const nonDuplicateTopicIds = Array.from(
        new Set(
            features
                .filter(feature => feature.topicId && feature.topicId > 0)
                .flatMap(feature => feature.topicId)
        )
    );
    return features
        .filter(feature => feature.topicId && feature.topicId > 0)
        .filter(
            feature =>
                feature.categoryNames && feature.categoryNames?.length > 0
        )
        .filter(f => nonDuplicateTopicIds.includes(f.topicId))
        .filter(f => f.longDescription);
}

export function transformFeaturesDto(
    features: VehicleDataVINFeatures[]
): UiFeature[] {
    return features.map(item => ({
        wersCode: item?.wersCode ?? '',
        shortDescription: item.shortDescription,
        title: item.title,
        categoryNames: item.categoryNames ?? [],
        topicId: item.topicId,
        longDescAvailable: !!item?.longDescription,
    }));
}

export function filterYmmResponse(
    features: VehicleDataYMMFeatures[]
): VehicleDataYMMFeatures[] {
    const filteredIds = Array.from(
        new Set(
            features
                .filter(feature => feature.longDescAvailable)
                .filter(feature => feature.topicId && feature.topicId > 0)
                .filter(feature => feature.categoryNames.length > 0)
                .flatMap(feature => feature.topicId)
        )
    );
    return features.filter(f => filteredIds.includes(f.topicId));
}
